import { Progress } from "@suraasa/placebo-ui"
import React, { useEffect, useState } from "react"

interface FakeProgressProps {
  duration?: number // total seconds to reach 95%
}

const FakeProgress: React.FC<FakeProgressProps> = ({ duration = 30 }) => {
  const [progress, setProgress] = useState<number>(0)

  useEffect(() => {
    let timer: NodeJS.Timeout
    const startTime = Date.now()

    const updateProgress = () => {
      const elapsedMs = Date.now() - startTime
      const elapsedSeconds = elapsedMs / 1000

      if (elapsedSeconds <= duration) {
        const newProgress = (elapsedSeconds / duration) * 95
        setProgress(newProgress)
      } else {
        setProgress(95)
      }
    }
    // eslint-disable-next-line prefer-const
    timer = setInterval(updateProgress, 100)

    return () => {
      clearInterval(timer)
      setProgress(0)
    }
  }, [duration])

  return (
    <div className="rounded-full border border-onSurface-200 bg-white p-0.25">
      <Progress
        value={progress}
        className="h-1.5 bg-transparent [&>div]:rounded-full [&>div]:bg-[linear-gradient(90deg,#8399FF_0%,#485CBA_80%,#1F3390_100%)]"
        size="lg"
      />
    </div>
  )
}

export default FakeProgress
